module.exports = __webpack_public_path__ + "static/media/OptionsLightGrey.3abd7b83.svg";